import React from "react";
import { Grid } from "@mui/material";
import { Select } from "../../../../componentsv2/Select";
import { OPCOES_SITUACAO_AGENDAMENTO } from "../../constants/agendamentoOptions";

export default function SelectSituacao({
  onChange,
  value,
  disabled = false,
  required = false,
  todas = true,
}) {
  const options = OPCOES_SITUACAO_AGENDAMENTO.map(({ value: optionValue, label }) => ({
    value: optionValue,
    text: label,
  }));

  todas && options.unshift({ value: "", text: "Todas" });

  return (
    <>
      <Grid container spacing={1} justify="center" alignItems="stretch">
        <Grid item xs={12}>
          <Select
            textAttribute="text"
            valueAttribute="value"
            required={required}
            disabled={disabled}
            onChange={onChange}
            value={value}
            label="Situação"
            variant="standard"
            arrayOptions={options}
            MenuProps={{ disableScrollLock: true }}
          />
        </Grid>
      </Grid>
    </>
  );
}
